import {
    IAccountResponse,
    IAngularUser,
    ICompanyResponse
} from '~/types/server.types';
import type { AuthenticatedGlobalContextValue } from '~/providers/base-global-context/authenticated-global.context';
import { User } from '~/models/user.model';

export function setCompanyAndAccountInStores({
    globalContext,
    account,
    company
}: {
    account?: IAccountResponse;
    company?: ICompanyResponse;
    globalContext: AuthenticatedGlobalContextValue;
}) {
    if (account) {
        globalContext.accountStore.update(account);
    }

    if (company) {
        globalContext.companyStore.update(company);
    }
}

export function loadUser(
    user: IAngularUser,
    globalContext: AuthenticatedGlobalContextValue
): User {
    const userModel = new User(user, globalContext);

    if (!globalContext) {
        return;
    }

    setCompanyAndAccountInStores({
        account: user.account,
        company: user.company,
        globalContext
    });

    return userModel;
}
